import Model from '../../ModelBinding/Model';
import InvitationCollection from './InvitationCollection';
import dayjs from 'dayjs';

export default class Invitation extends Model {
  public organization?: { name: string, role: string };
  public invited_by?: { firstname: string, lastname: string };
  public firstname?: string;
  public lastname?: string;
  public email?: string;
  public phone?: string;
  public accepted?: boolean;
  public role?: string;
  public notified_at?: dayjs.Dayjs;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.organization = this.getOriginalAttribute('organization') as { name: string, role: string };
    this.invited_by = this.getOriginalAttribute('invited_by') as { firstname: string, lastname: string };
    this.firstname = this.getStringAttribute('firstname');
    this.lastname = this.getStringAttribute('lastname');
    this.email = this.getStringAttribute('email');
    this.phone = this.getStringAttribute('phone');
    this.accepted = this.getBooleanAttribute('accepted');
    this.role = this.getStringAttribute('role');
    this.notified_at = this.getDateAttribute('notified_at');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
  }

  static getCollection() {
    return InvitationCollection;
  }
}
